var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYourSolarEqu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M0 20.308h16.923V0H0v20.308zM0 44h16.923V23.692H0V44zm20.308 0H37.23V23.692H20.308V44zm20.307 0h16.923V23.692H40.615V44zM20.308 20.308H37.23V0H20.308v20.308zM40.615 0v20.308h16.923V0H40.615z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYourSolarEqu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/your-solar-equ.1e23dcdda05460fb0c41101e553fbae2.svg";